import { render, staticRenderFns } from "./BanksPsuType.vue?vue&type=template&id=392bba9e"
import script from "./BanksPsuType.vue?vue&type=script&lang=js"
export * from "./BanksPsuType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports